module.exports = __webpack_public_path__ + "img/feedback6-2.f18eb76f.jpg";